<form class="form" [formGroup]="returnReasonForm" (ngSubmit)="returnCaseWithReason(returnReasonForm)">
   <form-group [title]="title" isLast="true">
      <field-holder>
         <mat-form-field appearance="outline">
            <mat-label>{{ 'CASES.RETURN_CASE_REASON' | translate }}</mat-label>
            <textarea matInput type="text" formControlName="returnReason" maxlength="250" required autocomplete="off"></textarea>
         </mat-form-field>
      </field-holder>
   </form-group>
   <form-footer>
      <button mat-stroked-button color="primary" mat-dialog-close (click)="closeDialog()" type="button" class="form-footer__button form-footer__button--secondary">
         {{ 'DIALOG.CANCEL' | translate }}
      </button>
      <button mat-flat-button color="primary" type="submit" class="form-footer__button form-footer__button--primary" [disabled]="!returnReasonForm.valid">
         {{ 'DIALOG.CONFIRM' | translate }}
      </button>
   </form-footer>
</form>
